/* RESPONSIBLE TEAM: team-automation-foundations */
import type HandoffToExternalTicket from 'embercom/models/operator/visual-builder/step/handoff-to-external-ticket';
import StepConfig, { type StepConfigParams } from '../step';

type HandoffToExternalTicketConfigurationParams = Omit<StepConfigParams, 'component'> & {
  integrationId?: number;
};

export default class HandoffToExternalTicketConfiguration extends StepConfig {
  declare step: HandoffToExternalTicket;

  constructor(params: HandoffToExternalTicketConfigurationParams) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-external-ticket',
      ...params,
    });
    this.step.integrationId = params.integrationId?.toString();
  }

  get alignment() {
    return 'left' as const;
  }
}
